angular.module('gym.tasks').factory('TaskTypes', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('task_types');
}]);
